import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const Ul = styled.ul`
  ${(props) => props.type === 'aside' && css`
    padding: 10px 0 0;
    margin-bottom: 15px;
    background-color: #fff;
    text-align: center;
  `};

  ${(props) => (props.type === 'asideIn' && css`
    display: none;
    flex-direction: column;
    grid-row-gap: 5px;
    position: absolute;
    top: 0;
    left: calc(100% + 20px);
    width: 218px;
    max-height: 300px;
    padding: 15px;
    background-color: #f2f2f2;
    overflow-y: scroll;
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.15));

    &.act {
      display: flex;
    }
  `)}

  ${(props) => (props.type === 'animation' && css`
    display: none;
    flex-direction: column;
    grid-row-gap: 5px;
    position: absolute;
    width: 218px;
    max-height: 300px;
    padding: 15px;
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.15));
    background-color: #f2f2f2;

    left: calc(100% + 243px);
    overflow-y: auto;

    top : ${(props) => props.top && props.top};

    &.act {
      display: flex;
    }
  `)}

  ${(props) => props.type === 'unit' && css`
    position: absolute;
    top: 0;
    width: 50%;
    height: 100%;
    overflow-y: auto;
    display: block;
    left: 0;
    background-color: #fff;

    ${props.page && css`
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      z-index: 1;
      box-shadow: -5px 0 10px 0;
    `}
  `}

  ${(props) => props.type === 'track' && css`
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
    background-color: #f9f9f9;
    overflow-y: auto;
  `}

  ${(props) => props.type === 'card' && css`
    display: flex;
    grid-column-gap: 30px;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `}

  ${(props) => props.type === 'dots' && css`
    display: flex;
    grid-column-gap: 10px;
    justify-content: center;
    margin-top: auto;
    margin-bottom: 30px;
    position: absolute;
    bottom : 7px;
    left : 50%;
    transform: translateX(-50%);
  `}
`;

export const List = (props) => {
  return (
    props.order ? <ol>{props.children}</ol> : <Ul type={props.type} className={props.className} top={props.top} page={props.page}>{props.children}</Ul>
  );
};

List.propTypes = {
  type : PropTypes.string,
  order : PropTypes.bool,
  className : PropTypes.string
};

List.defaultProps = {
  type : 'aside',
  order : false
};